import React, { BaseSyntheticEvent, SyntheticEvent } from 'react';

import styles from './FAQItem.module.css';

interface FaqItemProps {
  image?: string
  no: number
  title: string
  items?: FaqList[]
  onImageClick: (typeNo: number, event: SyntheticEvent) => void
  onListClick: (item: any, event: SyntheticEvent) => void
}

interface FaqList {
  NO: number
  TITLE: string
}

function FaqItem (props: FaqItemProps) {
  const events = {
    imageBox: {
      onClick: (type: number, event: SyntheticEvent) => {
        event.preventDefault();
        props.onImageClick(type, event);
      },
      handleMouseEnter: (event: BaseSyntheticEvent) => {
        event.preventDefault();
      },
      handleMouseLeave: (event: BaseSyntheticEvent) => {
        event.preventDefault();
      }
    },
    list: {
      onClick: (item: any, event: SyntheticEvent) => {
        event.preventDefault();
        props.onListClick(item, event);
        // alert(`게시글 이동\n/about/inquire-view>html?id=${no}`)
      },
      handleMouseEnter: (event: BaseSyntheticEvent) => {
        event.preventDefault();
      },
      handleMouseLeave: (event: BaseSyntheticEvent) => {
        event.preventDefault();
      }
    }
  };

  return (
    <div className={styles.faq}>
      <div className={styles.imageBox}
        onClick={events.imageBox.onClick.bind(null, props.no)}
        onMouseEnter={events.imageBox.handleMouseEnter}
        onMouseLeave={events.imageBox.handleMouseLeave}
        >
        <img className={styles.image} src={props.image} alt={props.title}></img>
      </div>
      <div className={styles.textBox}>
        <p className={styles.title}>{props.title}</p>
        <div className={styles.ul}>
          {props.items?.map((item) => {
            const content = item.TITLE;
            return (
              <div
                className={styles.li}
                key={item.NO}
                onClick={events.list.onClick.bind(null, item)}
                onMouseEnter={events.list.handleMouseEnter}
                onMouseLeave={events.list.handleMouseLeave}
              >
                <span className={styles.dot}>●</span>
                <span className={styles.contents}>{content}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

FaqItem.defaultProps = {
  items: []
};

export default FaqItem;
